export default function fadeIn() {
  const loadMoreWrapper = document.querySelector('.load-more');
  const loadMoreButton = document.querySelector('.load-more__button');
  const entryGrid = document.querySelector('.entry-grid');

  if (!loadMoreWrapper || !loadMoreButton || !entryGrid) {
    return;
  }

  const url = loadMoreButton.dataset.url;
  const totalPages = parseInt(loadMoreButton.dataset.totalPages, 10);

  loadMoreButton.addEventListener('click', () => {
    const count = parseInt(loadMoreButton.dataset.count, 10);

    loadMoreButton.classList.add('button__loading');
    loadMoreButton.innerText = 'Loading...';
    loadMoreButton.disabled = true;

    return fetch(`${url}/p${count}`)
      .then((response) => response.text())
      .then((response) => {
        const doc = new DOMParser().parseFromString(response, 'text/html');
        const entries = doc.querySelectorAll('.entry-grid__content');

        entries.forEach((element) => {
          entryGrid.append(element);

          setTimeout(() => {
            element.classList.add('fade-in--in-view');
          }, 50);
        });

        if (count === totalPages) {
          loadMoreWrapper.remove();
          return;
        }

        loadMoreButton.innerText = 'Load More';
        loadMoreButton.disabled = false;
        loadMoreButton.dataset.count = count + 1;
      });
  });
}
